import React, { useState, useContext } from "react";
import { Box, Button, CardContent, Input, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ReactComponent as UploadIcon } from "../../../images/uploadIcon.svg";
import { ReactComponent as ExportAuto } from "../../../images/exportAuto.svg";
import * as XLSX from "xlsx"; // Import the XLSX library
import ALMConnectionPage from "../../main-pages/input-pages/ALMConnection/ALMConnectionPage";
import TestcaseSelection from "../../popup-components/TestcaseSelection";
import {
  importExcelFileFormat,
  modifyTestCaseData,
} from "../../../services/webServices";
import { LoadingModalContext, MessagePopupContext } from "../ServicePage";
import MessagePopup from "../../popup-components/MessagePopup";
 
const UploadBox = ({ setTestCase }) => {
  const [openTestCasePopup, setOpenTestCasePopup] = useState(false);
  const [testCasesData, setTestCasesData] = useState([]);
  // const [pageSourceInput, setPageSourceInput] = useState("");
  const [uploadedFile, setUploadedFile] = useState(""); // State to store uploaded file
  const [popupOpen, setPopupOpen] = useState(false);
  const [openProjectPage, setOpenProjectPage] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const { setMessagePopup, setMessage } = useContext(MessagePopupContext);
 
  const { setLoadingState } = useContext(LoadingModalContext);
 
  // Handler for file upload
  const handleFileUpload = (e) => {
    setLoadingState({
      open: true,
      message: "Uploading your input file",
      progress: null
    });
    const allResponses = [];
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      const isExcelXLSX = fileName.endsWith(".xlsx");
      const isExcelXLS = fileName.endsWith(".xls");
      const isCSV = fileName.endsWith(".csv");
 
      if (!isExcelXLSX && !isExcelXLS && !isCSV) {
        setPopupMessage("Please upload a valid Excel file.");
        setPopupOpen(true);
        return;
      }
 
      setUploadedFile(file);
      setTestCasesData([]);
      setOpenTestCasePopup(false);
 
      const reader = new FileReader();
 
      reader.onload = async (event) => {
 
        try {
          let jsonData = [];
 
          if (isExcelXLSX || isExcelXLS) {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            if (!sheetName) {
              setPopupMessage("The uploaded Excel file has no sheets.");
              setPopupOpen(true);
              // setLoadingState({
              //   open: true,
              //   message: "Uploading your input file",
              //   progress: null,
              // });
              return;
            }
            const worksheet = workbook.Sheets[sheetName];
            jsonData = XLSX.utils.sheet_to_json(worksheet);
          } else if (isCSV) {
            const text = event.target.result;
            const workbook = XLSX.read(text, { type: "string" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            jsonData = XLSX.utils.sheet_to_json(worksheet);
          }
 
          if (!jsonData.length) {
            setPopupMessage("The Excel file is empty or has invalid format.");
            setPopupOpen(true);
            // setLoadingState({
            //   open: true,
            //   message: "Uploading your input file",
            //   progress: null,
            // });
            return;
          }
 
          // const formattedData = await modifyTestCaseData(JSON.stringify(jsonData));
          // if (formattedData.data.length === 0) {
          //   setPopupMessage("No valid test cases found in the file.");
          //   setPopupOpen(true);
          // }
          
          const response = await modifyTestCaseData(JSON.stringify(jsonData));

          if (response?.data?.length === 0) {
            setPopupMessage("Error processing some test cases. Please check the file format and try again.");
            setPopupOpen(true);
            return;
          }

          const formattedData = Array.isArray(response.data)
            ? response.data
            : [response.data];

          if (!formattedData.length) {
            console.warn("No valid data returned. Using original input.");
            setTestCasesData(jsonData);
          } else {
            setTestCasesData(formattedData);
          }
         
          setOpenTestCasePopup(true);
        } catch (error) {
          console.error("Error processing file:", error);
          setPopupMessage("Something went wrong while importing the file.");
          setPopupOpen(true);
        } finally {
          setLoadingState({
            open: false,
            message: "",
            progress: null,
          });
        }
      };
 
      reader.onerror = () => {
        setPopupMessage("Failed to read the file. Please try again.");
        setPopupOpen(true);
      };
 
      // Read as array buffer for Excel formats; as text for CSV
      if (isExcelXLSX || isExcelXLS) {
        reader.readAsArrayBuffer(file);
      } else if (isCSV) {
        reader.readAsText(file);
      }
      setUploadedFile("");
    }
  };

  const importTestCases = async () => {
    setOpenProjectPage(true);
  };
  // const [isDisabled, setIsDisabled] = useState(true);
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(true);
  return (
    <Box
      sx={{
        display: "flex",
        // justifyContent: "center",
        // alignItems: "flex-start",
        // minHeight: "100vh",
        // paddingTop: "10vh", // Moves it slightly down from the top
        bgcolor: "#f5f5f5", // Optional background color
      }}
    >
      <Box sx={{ width: 500 }}>
        <form>
          <CardContent
            sx={{
              width: 570,
              bgcolor: "white",
              borderRadius: 2,
              // marginBottom: 6,
              boxShadow: 3,
              // padding: 2,
            }}
          >
            <Input
              fullWidth
              disableUnderline
              multiline
              minRows={5}
              maxRows={10}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      color: "gray",
                    }}
                  />
                </InputAdornment>
              }
              placeholder="Enter Test Case Details"
              sx={{
                color: "black",
                bgcolor: "transparent",
                padding: "10px 10px 10px 33px",
                paddingRight: "50px",
                marginTop: "5px",
                zIndex: 1,
                "&:hover, &:focus": {
                  border: "none",
                },
              }}
            />
            <hr style={{ borderColor: "rgba(0, 0, 0, 0.12)" }} />
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Button
                startIcon={<UploadIcon />}
                component="label"
                sx={{
                  textTransform: "none",
                  marginRight: "15px",
                  color: "#49A3FF",
                }}
              >
                Upload
                <input
                  value={uploadedFile}
                  type="file"
                  accept=".xlsx, .xls, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv"
                  hidden
                  onChange={handleFileUpload}
                />
              </Button>
              <Button
                startIcon={
                  <ExportAuto
                    style={{
                      opacity:  1, // Dim the icon
                      pointerEvents: "none", // Prevent interaction
                    }}
                  />
                }
                sx={{
                  textTransform: "none",
                  color: "#49A3FF",
                  justifyContent: "end",
                }}
                onClick={importTestCases}
              >
                Import 
              </Button>
            </Box>
          </CardContent>
        </form>
      </Box>
      {openTestCasePopup === true && (
        <TestcaseSelection
          testCases={testCasesData}
          setTestCasesData={setTestCasesData}
          setTestCase={setTestCase}
        />
      )}
      {openProjectPage && (
        <ALMConnectionPage
          issueType="Test Cases"
          setPageCloser={setOpenProjectPage}
        />
      )}
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
    </Box>
  );
};
 
export default UploadBox;